module.exports = __webpack_public_path__ + "static/media/3.acedd3a1.jpg";